var map = {
	"./1efa_edit.pdb": 187,
	"./1gvp.pdb": 188,
	"./1jz8.pdb": 189,
	"./1lbg.pdb": 190,
	"./1mzt.pdb": 191,
	"./2g3p.pdb": 192,
	"./colors": 34,
	"./colors.json": 34,
	"./data": 35,
	"./data.json": 35,
	"./g3p.pdb": 193,
	"./g7p_pepfold.pdb": 194,
	"./g9p_pepfold.pdb": 195
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;



//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*$
// module id = 197
// module chunks = 0